import React, { createContext, useContext, useEffect, useState } from "react";
import defaultConfig from "./defaultConfig";
import * as _ from "lodash";
import {getLocalisationConfig, getConfigVersion } from "../../Constants/config";
import {_getLocalisationConfigLanguage, _getSupportedLanguage} from "../../Utils/Network/Config";
import { _getItemFromLocal, _setItemInLocal } from "../../Utils/Helpers/LocalKeys";
import {ELocalization} from "./ELocalization"
import { _getItemFromSession } from '../../Utils/Helpers/SessionKeys';
import { ELANGUAGEKEYS } from "../../Utils/Enums/ELanguageKeys";
import { useLocation } from "react-router-dom";



const supportedLanguages : {[key: string]: string} = {};
const langForApiMap: {[key: string]: string} = {};
const LocalizationStringsCache = "localization-strings-cache"


const stringToDynamic = (value: string,dynamicValues?:string[]) => {

  let iterator=0;
  while(value!==undefined && value.indexOf(ELocalization.DYNAMIC_STRING)>=0){
      value = value.replace(ELocalization.DYNAMIC_STRING,dynamicValues? dynamicValues[iterator]: "");
    iterator++;
  }
  return value;
}

const TranslationContext = createContext({
  language: "eng",
  t: (key: string, dynamicValues?:string[]) => {
    return key;
  },
  supportedLanguages,
  setLanguage: (langauge: string) => {},
});


const toSentenceCase = (key: string) => {
  let convertedKey = key[0] + key.slice(1, key.length).toLowerCase();
  convertedKey = convertedKey.split("_").join(" ");
  return convertedKey;
};

export const languageForApi = (language: string) => {
  if (language) {
    return langForApiMap[language as keyof typeof langForApiMap] || "English";
  }
  return "English";
};

export const getConfig = async (lang = "", getDataFromCache = false) => {
  try{
    const cache = await caches.open(LocalizationStringsCache);
    const languageForApiValue = languageForApi(lang);
    const languageURL= getLocalisationConfig+languageForApiValue;
    try {
      if(getDataFromCache) {
        const cachedResponse = await cache.match(languageForApiValue)
        if(cachedResponse) {
          const jsonResponse = await cachedResponse.json();
          return jsonResponse
        } 
      }
    } catch (error) {
    }
      
    await cache.delete(languageForApiValue);
    const response=await _getLocalisationConfigLanguage(languageURL);
    const cacheResponse: Response = new Response(JSON.stringify(response));
    cache.put(languageForApiValue, cacheResponse);
    return response;
  }catch{
    return defaultConfig;
  }
};

export const TranslationProvider = ({ children }: any) => {
  const localLanguage=_getItemFromLocal("_lang")!==null ? _getItemFromLocal("_lang") : ELANGUAGEKEYS.ENGLISH;
  const location = useLocation();
  const [preventApisDuringAuthorize, setPreventApisDuringAuthorize] = useState(true);
  const [lang, setLang] = React.useState(() => {
    if(window.location.pathname.indexOf("/authorise") > -1)
      return ""
    return (localLanguage || ELANGUAGEKEYS.ENGLISH)
  });
  const [configObject, setConfigObject] = useState(defaultConfig);

  const t = (key: string, dynamicValues?:string[]) => {
    const newTranslation =
    configObject && typeof configObject.localisation_strings !== "undefined" &&
      _.has(configObject.localisation_strings, key)
        ? configObject.localisation_strings[
            key as keyof typeof configObject.localisation_strings
          ]
        : defaultConfig.localisation_strings[
            key as keyof typeof defaultConfig.localisation_strings
          ]
    const newDynamicTranslation = stringToDynamic(newTranslation,dynamicValues);
    return typeof newDynamicTranslation !== "undefined"
      ? newDynamicTranslation
      : toSentenceCase(key);
  };

  const setLanguage = (language: string) => {
    setLang(language);
    _setItemInLocal("_lang",language);
  };

  const getAllLang = async(lang: string) =>{
    const dataObj = {
      app_id: "jhh-mobile-app",
    };
    // let response;
    // if(_getItemFromSession("_pnp") !== "true") {
    const response = await _getSupportedLanguage(dataObj);
    const crmMailData = _.get(response,"contents.crm_emails[0]",{});
    _setItemInLocal("cr",JSON.stringify(crmMailData))
    // } else {
      // response = await _getSupportedLanguage(dataObj);
      // response = {};
    // }
    const supportedLanguageArray = _.get(response, "contents.supported_languages", []);
    let oldLanguageVersion = 0;
    let newLanguageVersion = 0;
    const oldSupportedLanguageArray = _getItemFromLocal("supported_languages_hp");
    let oldSupportedLanguageArrayData: typeof supportedLanguageArray;
    if(oldSupportedLanguageArray) {
      try {
        oldSupportedLanguageArrayData = JSON.parse(oldSupportedLanguageArray);
        if (oldSupportedLanguageArrayData.length !== 0) {
          oldSupportedLanguageArrayData.forEach((item: {code: string, display_name: string, language_version: number}) => {
            if (_.get(item, "code") === lang) {
              oldLanguageVersion = _.get(item, "language_version");
            }
          });
        }
      } catch (error) {
      }
    }
    
    if(supportedLanguageArray.length !== 0){
      supportedLanguageArray.map((item: {code: string, display_name: string, language_version: number}) =>{
        const key = _.get(item, "code");
        const value = _.get(item, "display_name");
        const name = _.get(item, "name");
        if (key === lang) {
          newLanguageVersion = _.get(item, "language_version");
        }
        supportedLanguages[key] = value;
        langForApiMap[key] = name;
      })
    }
    
    if(newLanguageVersion !== 0 && newLanguageVersion !== oldLanguageVersion) {
      _setItemInLocal("supported_languages_hp", JSON.stringify(supportedLanguageArray));
      const cache = await caches.open(LocalizationStringsCache);
      await cache.delete(languageForApi(lang));
      return false;
    }
    return true;
  }

  useEffect(() => {
    (async () => {
      if (!preventApisDuringAuthorize) {
        const getDataFromCache = await getAllLang(lang);
        const data = await getConfig(lang, getDataFromCache);
        setConfigObject(data);
      }
    })();
  }, [lang, preventApisDuringAuthorize]);

  useEffect(() => {
    if(location.pathname !== `/authorise`) {
      setPreventApisDuringAuthorize(false);
    }
  },[location.pathname])


  return (
    <TranslationContext.Provider
      value={{
        language: lang,
        t,
        supportedLanguages,
        setLanguage,
      }}
    >
      {children}
    </TranslationContext.Provider>
  );
};

export default () => useContext(TranslationContext);
